import {usePtV2Context} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Context.ts";
import type {PtV2DatasetKey} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Classes.ts";
import {periodCaption, periodLabel} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Format.ts";
import {usePtV2SourcesQuery} from "~/experiments/pages/payment-terms-v2/usePaymentTermsV2Queries.ts";

/**
 * The period caption for a tab's KPI row.
 * Without a dataset (Overview): the total-spend period, else the common workpaper period when the datasets agree.
 * With one: that dataset's own period, only when the datasets disagree (`periodsAligned` false).
 */
export function usePtV2Period(dataset?: PtV2DatasetKey): string | null {
    const {summary, hasData} = usePtV2Context();
    const kpis = summary?.kpis;
    const aligned = kpis?.periodsAligned ?? true;
    const sourcesQ = usePtV2SourcesQuery(hasData && !aligned && dataset != null);
    if (!dataset) return periodCaption(kpis?.totalSpendL12mPeriod ?? kpis?.period);
    if (aligned) return null;
    const ds = sourcesQ.data?.datasets.find(d => d.dataset === dataset);
    const label = ds ? periodLabel(ds.periodStart, ds.periodEnd) : null;
    return label ? `Data period · ${label}` : null;
}
